import { IBusinessLocation, PagingResult } from 'models';
import { client } from 'shared';

export function getBusinessLocations(): Promise<PagingResult<IBusinessLocation>> {
    return client('api/business-location/');
}

export function patch(businessLocationId: number, body: Partial<IBusinessLocation>) {
    return client(`api/business-location/${businessLocationId}/`, {
        body,
        method: 'PATCH',
    });
}
export function addPhotos(businessLocationId: number, photos: File[]) {
    return Promise.all(
        photos.map((photo) => {
            const formData = new FormData();
            formData.append('title', photo.name);
            formData.append('location', businessLocationId.toString());
            formData.append('image', photo, photo.name);

            return client('api/location-photo/', { method: 'POST', body: formData }, false);
        }),
    );
}

export function deletePhoto(photoId: number) {
    return client(`api/location-photo/${photoId}/`, { method: 'DELETE' });
}
